import React, { useState } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import CautionParticuliers from "../../../components/questions/CautionParticuliers";
import ButtonText from "../../../components/buttons/button.text";
import SelectDepartement from "../../../components/selects/select.departement";
import { ToolTipPerso } from "../../../components/selects/tooltip_perso";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import DeboursQuestion from "../../../components/questions/DeboursQuestion";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires";
import AccessoiresQuestion from "../../../components/questions/AccessoiresQuestion";
import {useSnackbar} from "notistack";

//Prêts aux particuliers garantis par une hypothèque légale de prêteur de deniers et une hypothèque conventionnelle dans l'acte de vente
// id simu 84

function Simulateur_A1_12(props) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  let currUser = JSON.parse(localStorage.getItem("user"));
  let currUserDep = 0;
  if (currUser.societe_zip.startsWith("97")) {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 3);
    currUserDep = parseInt(trimedZip);
  } else {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 2);
    currUserDep = parseInt(trimedZip);
  }
  const [simu89, setSimu89] = useState(null);
  const [simu90, setSimu90] = useState(null);
  const [sansGarantieHypo, setSansGarantieHypo] = useState(0);
  const [avecGarantieHypo, setAvecGarantieHypo] = useState(0);
  const currentIdSimu = 84;
  const [departement, setDepartement] = useState(0);
  const [pretRealise, setPretRealise] = useState(0);
  const [montantPret, setMontantPret] = useState(0);
  const [montantPretHp, setMontantPretHp] = useState(0);
  const [montantPretHc, setMontantPretHc] = useState(0);
  const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
  const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);
  const [modifAccessoires, setModifAccessoires] = useState(0);
  const [tauxAccessoires, setTauxAccessoires] = useState(20);

  const handleChange = async (setter, value, key) => {
    if (key === "taux_accessoires" && value >= 100) {
      enqueueSnackbar('Le pourcentage maximal des accessoires est de 100%', {
        variant: 'warning'
      });
      value = 100
    }
    if (setter) setter(value);
    setInRedux(setter, value, key);
  };

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };

  function setInRedux(setter, value, key) {
    let object = {
      simulateurid: currentIdSimu,
      departementid: parseInt(departement),
      dependances: [
        ...(simu89 ? [simu89] : []),
        ...(simu90 ? [simu90] : []),
      ],
      inputs: {
        pret_realise: parseInt(pretRealise),
        montant_pret: parseInt(montantPret),
        montant_pret_hp: parseInt(montantPretHp),
        montant_pret_hc: parseInt(montantPretHc),
        montant_deb_add: parseInt(montantDeboursAdditionnels),
        debours_additionnels: parseInt(deboursAdditionnels),
        modif_accessoires: parseInt(modifAccessoires),
        taux_accessoires: parseFloat(tauxAccessoires),
        convention_honoraires : parseInt(props.conventionHonoraires),
      },
      pdfInputs: {
        nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
        object_convention_honoraires : props.objectConventionHonoraires,
        montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
        nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
        adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
      },
    };
    //For values coming from components
      if (key) {
        if (key === "debours_additionnels") {
          if (value === 0) {
            setMontantDeboursAdditionnels(0)
            Object.assign(object["inputs"], { montant_deb_add: parseInt(0) });
          }
          Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
        }
        if (key === "montant_deb_add") {
          Object.assign(object["inputs"], { montant_deb_add: parseInt(value) });
        }
        if (key === "modif_accessoires") {
          if (value === 0) {
            setTauxAccessoires(20);
            Object.assign(object["inputs"], { taux_accessoires: parseFloat(20) });
          }
          Object.assign(object["inputs"], { modif_accessoires: parseInt(value) });
        }
        if (key === "taux_accessoires") {
          Object.assign(object["inputs"], { taux_accessoires: parseFloat(value) });
        }
      }
    //For internal settings
    if (setter === setPretRealise) {
      Object.assign(object["inputs"], { pret_realise: parseInt(value) });
    }
    if (key === 'simu89') {
      setSimu89(value);
      Object.assign(object, {
        dependances: [
          value,
          ...(simu90 ? [simu90] : [])
        ]
      });
    }

    if (key === 'simu90') {
      setSimu90(value);
      Object.assign(object, {
        dependances: [
          ...(simu89 ? [simu89] : []),
          value
        ]
      });
    }

    if (setter === setMontantPretHp) {
      Object.assign(object["inputs"], { montant_pret_hp: parseInt(value) });
    }

    if (setter === setMontantPretHc) {
      Object.assign(object["inputs"], { montant_pret_hc: parseInt(value) });
    }

    if (setter === setMontantPret) {
      Object.assign(object["inputs"], { montant_pret: parseInt(value) });
    }

    if (setter === setDepartement) {
      object.departementid = parseInt(value);
    }

    // State cleaning for cautionnement
    if (setter === setSansGarantieHypo) {
      if (value === 0) {
        const dependances = [
          ...(simu89 ? [simu89] : []),
          ...(simu90 ? [simu90] : []),
        ];
        const index = dependances.findIndex((obj) => obj.simulateurid === 89);
        if (index !== -1) {
          dependances.splice(index, 1);
        }
        setSimu89(null);
        Object.assign(object, {
          dependances: dependances
        });
      }
    }

    if (setter === setAvecGarantieHypo) {
      if (value === 0) {
        const dependances = [
          ...(simu89 ? [simu89] : []),
          ...(simu90 ? [simu90] : []),
        ];
        const index = dependances.findIndex((obj) => obj.simulateurid === 90);
        if (index !== -1) {
          dependances.splice(index, 1);
        }
        setSimu90(null);
        Object.assign(object, {
          dependances: dependances
        });
      }
    }

    if (setter === props.setConventionHonoraires) {
        if(value === 0){
          props.setNombreConventionHonoraires(1);
          props.setObjectConventionHonoraires(null);
          props.setMontantConventionHonoraires(null);
          props.setNomSignataireConventionHonoraires(null);
          props.setAdresseSignataireConventionHonoraires(null);
          Object.assign(
            object["inputs"], { convention_honoraires : parseInt(value) },
            object["pdfInputs"], {
              nombre_convention_honoraires : null,
              object_convention_honoraires : null,
              montant_convention_honoraires : null,
              nom_signataire_convention_honoraires : null,
              adresse_signataire_convention_honoraires : null
            },
          );
        } else {
          Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
        }
      }

      if (setter === props.setNombreConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nombre_convention_honoraires : parseInt(value) });
      }

      if (setter === props.setObjectConventionHonoraires) {
        Object.assign(object["pdfInputs"], { object_convention_honoraires : value });
      }

      if (setter === props.setMontantConventionHonoraires) {
        Object.assign(object["pdfInputs"], { montant_convention_honoraires : parseInt(value)});
      }

      if (setter === props.setNomSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nom_signataire_convention_honoraires : value });
      }

      if (setter === props.setAdresseSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { adresse_signataire_convention_honoraires : value });
      }
    //props.contentDep(object);
    if (props.isParent) {
      dispatch(setSimulateurObject(object));
    } else {
      object.departementid = parseInt(props.departementId);
      props.dependances(object);
    }
  }

  return (
    <>
      {props?.isParent === true && props.departements !== "" ? (
        <div style={styles.container}>
          <div className="cardSimulateur">
            {/* <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id} /> */}
            <TextSimulateurTitle title={"Prêts aux particuliers garantis par une HLPD (Hypothèque légale de prêteur de denier) et/ou une hypothèque conventionnelle (HC) et/ou un cautionnement (garanti ou non par une HC)"} currentSimuId={props.simulateur.id} />

            <TextfieldRemarques handleChange={handleChangeRemarque} />

            <p style={styles.cardSubTitle}>
              Pour le prêt, acte tarifé au titre du Tableau 5, n° 137 (Art A444-143).
              Cautionnement associé acte tarifé au titre du Tableau 5, n° 111 (Art A444-127).
            </p>

            {props?.isParent === true && props.departements !== "" ? (
              <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>Département :</div>

                <SelectDepartement
                  items={props.departements}
                  nameField={"name"}
                  defaultValue={currUserDep}
                  optionValue={"id"}
                  handleChange={handleChange}
                  setter={setDepartement}
                />
              </div>
            ) : (
              <></>
            )}

            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>
                Le prêt hypothécaire est réalisé :
                <ToolTipPerso
                  title={
                    "Pour rappel : par « acte séparé » signifie que la convention est la disposition principale de l'acte (un prêt) et « dans le même acte » correspond à la situation où des conventions juridiques distinctes et indépendantes y sont contenues (par exemple une vente et un prêt)."
                  }
                />
              </div>
              <ButtonText handleChange={handleChange} setter={setPretRealise} defaultValue={0} />
            </div>

            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>
                Indiquer le montant total du prêt ou capitaux empruntés :
              </div>
              <TextfieldNumber
                handleChange={handleChange}
                type={"number"}
                placeholder={"Indiquer le montant"}
                setter={setMontantPret}
              />
            </div>

            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>
                Indiquer le montant du prêt garanti par une hypothèque légale de prêteur de deniers :
              </div>
              <TextfieldNumber
                handleChange={handleChange}
                type={"number"}
                placeholder={"Indiquer le montant"}
                setter={setMontantPretHp}
              />
            </div>

            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>Indiquer le montant du prêt garanti par l'HC :</div>
              <TextfieldNumber
                handleChange={handleChange}
                type={"number"}
                placeholder={"Indiquer le montant"}
                setter={setMontantPretHc}
              />
            </div>
            <AccessoiresQuestion
              handleChange={handleChange}
              modifAccessoires={modifAccessoires}
              setModifAccessoires={setModifAccessoires}
              setTauxAccessoires={setTauxAccessoires}
            />
            <CautionParticuliers
              simulateur={props.simulateur}
              departementId={departement}
              handleChange={handleChange}
              sansGarantieHypo={sansGarantieHypo}
              avecGarantieHypo={avecGarantieHypo}
              setSansGarantieHypo={setSansGarantieHypo}
              setAvecGarantieHypo={setAvecGarantieHypo}
              montantPret={montantPret}
            />

            <DeboursQuestion
                handleChange={handleChange}
                deboursAdditionnels={deboursAdditionnels}
                setDeboursAdditionnels={setDeboursAdditionnels}
                setMontantDeboursAdditionnels={setMontantDeboursAdditionnels}
            />
            <ConventionHonoraires
              handleChange={handleChange}
              conventionHonoraires={props.conventionHonoraires}
              setConventionHonoraires={props.setConventionHonoraires}
              nombreConventionHonoraires={props.nombreConventionHonoraires}
              setNombreConventionHonoraires={props.setNombreConventionHonoraires}
              objectConventionHonoraires={props.objectConventionHonoraires}
              setObjectConventionHonoraires={props.setObjectConventionHonoraires}
              montantConventionHonoraires={props.montantConventionHonoraires}
              setMontantConventionHonoraires={props.setMontantConventionHonoraires}
              nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
              setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
              adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
              setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
            />
          </div>
        </div>
      ) : (
        <div style={styles.cardRowChild}>
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Le prêt hypothécaire est réalisé :
              <ToolTipPerso
                title={
                  "Pour rappel : par « acte séparé » signifie que la convention est la disposition principale de l'acte (un prêt) et « dans le même acte » correspond à la situation où des conventions juridiques distinctes et indépendantes y sont contenues (par exemple une vente et un prêt)."
                }
              />
            </div>
            <ButtonText handleChange={handleChange} setter={setPretRealise} defaultValue={0} />
          </div>

          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Indiquer le montant total du prêt ou capitaux empruntés :
              <ToolTipPerso
                title={"Les accessoires sont compris et évalués au bordereau à concurrence de 20% du capital emprunté."}
              />
            </div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setMontantPret}
            />
          </div>

          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Indiquer le montant du prêt garanti par une hypothèque légale de prêteur de deniers :
            </div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setMontantPretHp}
            />
          </div>

          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Indiquer le montant du prêt garanti par l'HC :</div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setMontantPretHc}
            />
          </div>
          <AccessoiresQuestion
            handleChange={handleChange}
            modifAccessoires={modifAccessoires}
            setModifAccessoires={setModifAccessoires}
            setTauxAccessoires={setTauxAccessoires}
          />
          <CautionParticuliers
            simulateur={props.simulateur}
            departementId={departement}
            handleChange={handleChange}
            sansGarantieHypo={sansGarantieHypo}
            avecGarantieHypo={avecGarantieHypo}
            setSansGarantieHypo={setSansGarantieHypo}
            setAvecGarantieHypo={setAvecGarantieHypo}
            montantPret={montantPret}
          />
          
        </div>
      )}
    </>
  );
}

export default Simulateur_A1_12;
